<script>
import OdemeDuzelt from './odeme_duzelt.vue'
import DuzeltmeDetay from './duzeltme_detay.vue'

export default {
  name: 'OdemeGecmisi',
  props:[
    "data"
  ],
  components:{ 
    OdemeDuzelt,
    DuzeltmeDetay
  },
  data() {
    return {
        form: {},
        title:'',
        modalOpenCount: 0,
        duzeltmeData:{},
        odemeDuzeltDetay:{},
        submitted: false,
        tahsilatData: {},
        isLoading: false,
        rows: [],
        totalData : {},
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: [
            {
              field: '',
              type: '',
            },
          ],
          page: 1,
          perPage: 50,
        },
        currentPage: 0,
        selected: 0,
        pageLength: 0,
        paginationOptions: {
          enabled: true,
          dropdownAllowAll: false,
          perPage: 50,
          setCurrentPage: 1,
          perPageDropdown: [50, 100, 200],
          nextLabel: 'Sonraki',
          prevLabel: 'Önceki',
          rowsPerPageLabel: 'Kayıt Göster',
          ofLabel: 'of',
          pageLabel: 'sayfa', // for 'pages' mode
          infoFn: params => `Bulunduğun Sayfa ${params.currentPage}`,
        },
        selectOptions: {
            enabled: false,
            selectOnCheckboxOnly: false,
            selectionInfoClass: 'custom-class',
            selectionText: 'adet kayıt seçildi',
            clearSelectionText: 'seçimi iptal et',
            disableSelectInfo: false,
            selectAllByGroup: false,
        },
        columns: [
        {
          label: 'Ödemeyi Alan',
          field: "user_name",
          sortable:false,
        },
        {
          label: 'Tarih',
          field: this.transaction_date,
          sortable:false,
        },
         {
          label: 'Açıklama',
          field: 'main_explaine',
          sortable:false,
        },
        {
          label: 'Satış',
          field: 'borc',
          sortable:false,
        },
        {
          label: 'Komisyon',
          field: 'commission',
          sortable:false,
        },
        {
          label: 'Tahsilat',
          field: 'collect',
          sortable:false,
        },
        {
          field: '#',
          label: '#',
          sortable:false,
        }
      ]
    }
  },
  watch:{
    data(props){
        this.rows = []
        this.totalData = {}
        this.form = props
        this.title = props.name
        this.updateParams({ columnFilters : props})
        this.loadItems()
    }
  },
  methods: {
    isAdmin(){
      const userdata = JSON.parse(localStorage.getItem('userdata'))
      return userdata.role_name == 'admin'
    },

    transaction_date(props){
      return this.formatDate(props.transaction_date,"DD.MM.YYYY HH:MM")
    },

    getTotalBalances(){
        this.$http.post(`dealers/${this.form.id}/balances/total `, this.serverParams)
        .then(response => this.totalData = response.data)
    },

    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      })
      this.loadItems()
    },
    onColumnFilter(params) {
      this.updateParams(params)
      this.loadItems()
    },
    loadItems() {
      this.getFromServer(this.serverParams).then(response => { 
            this.totalRecords = response.totalRecords
            this.pageLength = response.pageLength
            this.currentPage = response.currentPage
            this.rows = response.rows
        })
      this.getTotalBalances()
    },
    getFromServer() {

        return new Promise((resolve, reject) => {
            this.$http.post(`dealers/${this.form.id}/balances`, this.serverParams)
            .then(res => {
                resolve({
                    rows: res.data,
                    totalRecords: res.data.total,
                    pageLength: res.data.last_page,
                    currentPage: res.data.current_page,
                })
            })
            .catch(error => {
                reject(error)
            })
        })
    },
    onSearch(params) {
       this.updateParams(params) 
       this.loadItems()
    },

    close(){
      this.$parent.$bvModal.hide('odeme_gecmisi')
    },

    odemeDuzeltOpen(props){
      this.odemeDuzeltDetay = props
      this.$parent.$bvModal.show('odeme_duzelt')
    },
    correctedItem(row, id){
      return Array.isArray(row.corrected) && row.corrected.includes(id) ? 'Düzeltildi' : '';
    },
    duzeltmeDetayModal({id, user_id, user_name}){ 
      this.modalOpenCount += 1;
      this.duzeltmeData = {id, user_id, user_name  }
      this.$parent.$bvModal.show('duzeltme_gecmisi')
    }
  },
};
</script>

<template>
  <b-modal id="odeme_gecmisi" size="xl" :title="title"  no-close-on-backdrop hide-footer>
    <OdemeDuzelt 
      :data="odemeDuzeltDetay" 
       @loadItems="loadItems"
      />

    <DuzeltmeDetay 
      :data="duzeltmeData" 
      :open="modalOpenCount" 
       @loadItems="loadItems"
      />
      

    <div class="row">
        <div class="col-md-12">
            <div class="text-end px-2 py-2 border border-1 bg-warning text-light">
                Satış Toplam: {{  $paraFormat(this.totalData.borc) }} |   Komisyon Toplam: {{  $paraFormat(this.totalData.commission) }} |   Tahsilat Toplam: {{  $paraFormat(this.totalData.collect) }} |   Bakiye Toplam: {{  $paraFormat(this.totalData.balance) }}
             </div>
        </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>Ödemeyi Alan</th>
                  <th>İşlem Tarihi</th>
                  <th>Kullanıcı Adı</th>
                  <th>İsim Soyisim</th>
                  <th>Açıklama</th>
                  <th>Satış</th>
                  <th>Komisyon</th>
                  <th>Tahsilat</th>
                  <th>Bakiye</th>
                  <th v-if="isAdmin()"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row,i) in rows" :key="i">
                  <td>{{ row.user_name }}</td>
                  <td>{{ row.transaction_date }}</td>
                  <td>{{ row.username }}</td>
                  <td>{{ row.fname }} {{ row.lname }}</td>
                  <td>{{ row.main_explaine }}</td>
                  <td>{{ $paraFormat(row.borc) }}
                    <u class="text-muted" @click="duzeltmeDetayModal(row)">{{ correctedItem(row, 2) }}</u>
                  </td>
                  <td>
                    {{ $paraFormat(row.commission) }}
                    <u class="text-muted"  @click="duzeltmeDetayModal(row)">{{ correctedItem(row, 1) }}</u>
                  </td>
                  <td> 
                      {{ $paraFormat(row.collect) }}
                    <u class="text-muted"  @click="duzeltmeDetayModal(row)">{{ correctedItem(row, 3) }}</u>
                  </td>
                  <td>{{ $paraFormat(row.balance) }}</td>
                  <td v-if="isAdmin()">
                    <button 
                      @click="odemeDuzeltOpen(row)"
                      class="btn btn-outline-warning btn-sm">
                      Düzenle
                    </button> 
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
</b-modal>
</template>